import { ProfileState } from '@web-solutions/store/types';

type ProfileSubset = Pick<ProfileState, 'email' | 'authorized' | 'is_unsubscriber'>;

export const profileSelectors: {
  [K in keyof ProfileSubset]: (state: { profile: ProfileSubset }) => ProfileSubset[K];
} = {
  email: (state) => state.profile.email,
  authorized: (state) => state.profile.authorized,
  is_unsubscriber: (state) => state.profile.is_unsubscriber,
};
